import React, { useRef, useState } from 'react';

import TextField from '@material-ui/core/TextField';

import CourtList from './CourtList';
import { findCourt } from '../../../app/data/courts';

const CourtPicker = ({ onChange, court, label = "Court Name", classes = '' }) => {
    const courtRef = useRef();
    const [matches, setMatches] = useState([]);

    const handleChange = () => {
        if (!courtRef.current.value) {
            setMatches([]);
            return;
        }

        setMatches(findCourt(courtRef.current.value));
    };

    const handleSelect = court => {
        setMatches([]);
        courtRef.current.value = court.name;
        onChange(court);
    }

    return <React.Fragment>
        <TextField
            fullWidth
            inputRef={courtRef}
            defaultValue={court?.name || ''}
            onChange={handleChange}
            className={classes}
            label={label}
        />
        <CourtList courts={matches} onSelect={handleSelect} />
    </React.Fragment>

};

export default CourtPicker;